import React from 'react';
import { Link } from 'react-router-dom';
import CONFIG from '@/lib/config';

export const Footer: React.FC = () => {
    return (
        <footer className="bg-[#1A4D4F] text-[#f5f5f5] py-12 px-6 sm:px-12 md:px-24">
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                    <div className="flex items-center gap-6">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/89bc6265b1a84995b7b85b1453a49e93/e937596a79e27aedd1ca37344ef2209cd6e8c5da2cc900e6c0f5467b6176325e?apiKey=89bc6265b1a84995b7b85b1453a49e93&"
                            alt="Nexilink Logo"
                            className="w-[150px] object-contain"
                        />
                    </div>
                    <p className="font-inter text-sm text-[#A4C3B2] max-w-md">
                        Digital onboarding och kompetensträning för välfärden.
                    </p>
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
                        <Link
                            to="/om-oss"
                            className="font-inter text-sm font-medium hover:text-[#A4C3B2] transition-colors"
                        >
                            Om oss
                        </Link>
                        {/* #324 — the footer is where people look for these, and
                            a policy that is only reachable from inside a signup
                            form is not really published. */}
                        <Link
                            to="/villkor"
                            className="font-inter text-sm font-medium hover:text-[#A4C3B2] transition-colors"
                        >
                            Användarvillkor
                        </Link>
                        <Link
                            to="/integritetspolicy"
                            className="font-inter text-sm font-medium hover:text-[#A4C3B2] transition-colors"
                        >
                            Integritetspolicy
                        </Link>
                        <a
                            href={`mailto:${CONFIG.CONTACT_EMAIL}`}
                            className="font-inter text-sm font-medium hover:text-[#A4C3B2] transition-colors"
                        >
                            {CONFIG.CONTACT_EMAIL}
                        </a>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-[#A4C3B2]/30 my-8"></div>

                {/* Copyright */}
                <div className="font-inter text-center text-sm">
                    © Copyright {new Date().getFullYear()}, Alla rättigheter förbehållna av Nexilink
                </div>
            </div>
        </footer>
    );
};